
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_9ckv7_69qb9_9",
  "container-override": "awsui_container-override_9ckv7_69qb9_14",
  "active": "awsui_active_9ckv7_69qb9_14",
  "header": "awsui_header_9ckv7_69qb9_36",
  "flexible": "awsui_flexible_9ckv7_69qb9_43",
  "handle": "awsui_handle_9ckv7_69qb9_47",
  "refresh": "awsui_refresh_9ckv7_69qb9_50",
  "header-content": "awsui_header-content_9ckv7_69qb9_54",
  "settings": "awsui_settings_9ckv7_69qb9_58",
  "fixed": "awsui_fixed_9ckv7_69qb9_66",
  "resizer": "awsui_resizer_9ckv7_69qb9_70"
};
  